<template>
  <div>
    <Select
      :itemSelected="measurement"
      :items="items"
      labelProp="name"
      :hasSearch="true"
      padding="md"
      :isDisabled="injectionId == null"
      placeholderSearch="Choose measurement"
      titleBottomSheet="Choose measurement"
      @update:itemSelected="selectedItemChanged"
      @showPopup="handleShowPopup"
      @hidePopup="handleHidePopup"
    />
  </div>
</template>

<script>
  import Select from '@/uikitBase/selects/vueSelect/Select';
  import { apiMeasurements } from '@/api/graphql/cloud/measurements';

  const ModelEvent = 'change';

  export default {
    name: 'SelectMeasurement',

    components: { Select },

    model: {
      prop: 'measurement',
      event: ModelEvent,
    },

    props: {
      measurement: {
        type: Object,
        default: null,
      },
      injectionId: {
        type: Number,
      },
    },

    data: () => ({
      items: [],
      isSelectOpened: false,
    }),

    watch: {
      injectionId: {
        handler() {
          if (this.injectionId) {
            this.initMeasurements();
          }
        },
        immediate: true,
      },
    },

    methods: {
      handleShowPopup() {
        this.isSelectOpened = true;
        this.$emit('showPopup');
      },
      handleHidePopup() {
        this.isSelectOpened = false;
        this.$emit('hidePopup');
      },

      selectedItemChanged(item) {
        this.$emit(ModelEvent, item);
      },

      async initMeasurements() {
        const { measurements } = await apiMeasurements.getMeasurementsShort(this.injectionId);
        this.items = measurements.map((measurement) => ({
          ...measurement,
          name: measurement.meta?.nm
            ? `${measurement.type} - ${measurement.meta.nm}nm`
            : measurement.name,
        }));
      },
    },
  };
</script>
